import {
  ArrowLeft,
  History,
  ChefHat,
  Coffee,
  Cookie,
  Droplets,
  ShoppingBasket,
  Wheat,
} from "lucide-react";
import { AREA_BY_ID, RESTAURANT_BY_ID } from "../../constants";
import { userAreas } from "../../lib/permissions";
import LanguageToggle from "../LanguageToggle";
import { useLanguage } from "../../i18n/LanguageContext";

const AREA_ICON = {
  kitchen: ChefHat,
  bakery: Wheat,
  pastry: Cookie,
  coffee_bar: Coffee,
  cleaning: Droplets,
};

// Sticky top bar of the employee app: back, brand, user info, transfer
// shortcut, request-list (cart) button.
export default function EmployeeHeader({
  user,
  cartCount,
  onSignOut,
  onOpenHistory,
  onOpenSheet,
}) {
  const { t } = useLanguage();
  const uAreas = userAreas(user);
  const firstArea = uAreas[0];
  const AreaIcon = AREA_ICON[firstArea] || ShoppingBasket;
  const areaNames = uAreas.map((a) => AREA_BY_ID[a]?.name).filter(Boolean).join(" · ");
  const restaurant = RESTAURANT_BY_ID[user.restaurant];

  return (
    <header className="safe-area-top sticky top-0 z-30 bg-[#F3EFE7]/85 backdrop-blur border-b border-[#E6E0D4]">
      <div className="max-w-6xl mx-auto px-4 md:px-8 h-16 flex items-center gap-3">
        <button
          onClick={onSignOut}
          aria-label={t("back")}
          className="h-9 w-9 rounded-full hover:bg-[#E9E3D6] flex items-center justify-center transition-colors"
        >
          <ArrowLeft size={18} />
        </button>
        <img
          src="/brand-mark.png"
          alt="Café Breizh · JGI Stock Operation"
          className="h-9 w-9 rounded-lg object-cover shrink-0"
          data-testid="brand-mark"
        />
        <div className="flex items-center gap-3 min-w-0">
          <div className="h-9 w-9 rounded-full bg-[#EDEAE2] flex items-center justify-center">
            <AreaIcon size={16} strokeWidth={1.8} />
          </div>
          <div className="min-w-0">
            <p className="text-[10px] tracking-eyebrow uppercase text-[#0B1F3A]/55 truncate">
              {restaurant?.brand} · {restaurant?.name}
            </p>
            <p className="text-sm font-medium leading-tight truncate">
              {user.name} · {areaNames}
            </p>
          </div>
        </div>
        <div className="flex-1" />
        <div className="hidden md:block"><LanguageToggle /></div>
        <button
          data-testid="order-history-btn"
          onClick={onOpenHistory}
          className="mr-2 flex items-center gap-2 rounded-full bg-white hover:bg-[#F3EFE7] border border-[#E6E0D4] text-[#0B1F3A] px-3 sm:px-4 h-10 transition-colors"
        >
          <History size={16} />
          <span className="text-sm font-medium hidden sm:inline">History</span>
        </button>
        <button
          onClick={onOpenSheet}
          className="relative flex items-center gap-2 rounded-full bg-[#0B1F3A] hover:bg-[#11294A] text-white px-3 sm:px-4 h-10 transition-colors"
        >
          <ShoppingBasket size={16} />
          <span className="text-sm font-medium hidden sm:inline">{t("list")}</span>
          {cartCount > 0 && (
            <span className="ml-1 min-w-5 h-5 px-1.5 rounded-full bg-[#F07C52] text-white text-[11px] flex items-center justify-center">
              {cartCount}
            </span>
          )}
        </button>
      </div>
    </header>
  );
}
